import { render } from "./membership-avatar.vue?vue&type=template&id=beaababc&lang=pug"
import script from "./membership-avatar.vue?vue&type=script&lang=js"
export * from "./membership-avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__